module.exports = __webpack_public_path__ + "static/img/appPage_2.6e72e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appPage_2.png
// module id = Vi1n
// module chunks = 1